import {axiosInstance} from "../instance";

const Login = (email, password, role) => {

    localStorage.removeItem('token');

    return axiosInstance
        .post('/api/login', {
            email,
            password,
            ...(role ? { role } : {})
        },{
            // transformRequest: (data, headers) => {
            //     console.log(headers);
            //     delete headers.token;
            // }
        }
    );
}

const GetLoggedUser = () => {
    return axiosInstance.get('/api/user-logged');
}

const RequestPasswordReset = (email) => {
    return axiosInstance.post('/api/password-reset-request', {email});
}

export {Login, GetLoggedUser, RequestPasswordReset};
